import { Currency } from '@/core/currency/interfaces';

const MZN: Currency = {
    name: 'Mozambican Metical',
    demonym: 'Mozambican',
    majorSingle: 'Metical',
    majorPlural: 'Meticais',
    codeNumeric: '943',
    symbol: 'MTn',
    symbolNative: 'MT',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MZN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MZN;
